<template>
  <div class="JsonEditor">
    <el-popover
      :popper-options="popoverOptions"
      ref="customAttrsPopover"
      placement="bottom-end"
      width="300"
      trigger="click"
      @after-leave="dynamicAttrKey = new Date().getTime()"
    >
      <form-item :label="$t('CampaignForm_Field_DynamicAttrs')">
        <el-autocomplete
          :key="dynamicAttrKey"
          ref="customAttrsInput"
          v-model="dynamicAttr"
          :fetch-suggestions="querySearchAttrs"
          @select="handleSelectAttr"
          :popper-append-to-body="true"
        />
      </form-item>
    </el-popover>
    <el-button-group class="JsonEditor-Buttons">
      <el-button
        type="primary"
        plain
        v-popover:customAttrsPopover
        @click="putCursor('customAttrsInput')"
        class="dropdown-btn"
        icon="el-icon-user-solid"
      />
    </el-button-group>
    <div ref="editor"></div>
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import { JSONEditor } from 'vanilla-jsoneditor'
import { querySearch } from '@/core/helpers'

export default {
  name: 'JsonEditor',

  components: { FormItem },

  props: {
    value: {
      required: true
    },
    template: {
      type: String,
      required: false
    }
  },

  data: function() {
    return {
      editor: undefined,
      dynamicAttrKey: '',
      dynamicAttr: '',
      currentState: undefined,
      popoverOptions: {
        modifiers: [
          'preventOverflow',
          'flip',
          'offset',
          'keepTogether',
          'arrow',
          this.hidePopover,
          'applyStyle'
        ]
      },
      cursorPosition: undefined
    }
  },

  computed: {
    content() {
      if (this.value && this.value !== '') return { text: this.value }

      if (this.template) return { text: this.template }

      return { text: '' }
    },
    valueIsEmpty() {
      if (!this.currentState) return false

      try {
        const currentStateObject = JSON.parse(this.currentState.text)
        return Object.keys(currentStateObject).length === 0
      } catch (e) {
        return false
      }
    }
  },

  watch: {
    valueIsEmpty(value) {
      this.$emit('value-is-empty', value)
    }
  },

  mounted() {
    this.refreshEditor()
  },

  updated() {
    this.refreshEditor()
  },

  methods: {
    refreshEditor() {
      const content = this.content
      if (!this.currentState) {
        this.currentState = content
      }

      this.updateEditor(this.currentState)
    },

    resetToDefault() {
      if (this.template !== undefined) {
        this.updateEditor({ text: this.template })
      }
    },

    updateEditor(content) {
      if (this.editor !== undefined) {
        this.editor.update(content)
      } else {
        this.createEditor(content)
      }
    },

    createEditor(content) {
      this.editor = new JSONEditor({
        target: this.$refs.editor,
        props: {
          content,
          mode: 'text',
          mainMenuBar: false,
          navigationBar: false,
          onChange: updatedContent => {
            const isContentEdited =
              !this.currentState || this.template !== updatedContent.text
            this.currentState = updatedContent
            this.$nextTick(() => {
              this.$emit('validation-result', this.editor.validate() === null)
              this.$emit('value-edited', isContentEdited)
            })
          },
          onSelect: selection => {
            this.cursorPosition = selection.ranges[0].head
          }
        }
      })
    },

    clear() {
      if (this.editor !== undefined) {
        this.editor.destroy()
        this.editor = undefined
        this.currentState = undefined
      }
    },

    querySearchAttrs(queryString, cb) {
      return querySearch(
        `tags`,
        {
          sort: 'title',
          show_aliases: 0,
          title: queryString,
          attribute_profile: 1
        },
        cb
      )
    },

    handleSelectAttr(item) {
      if (this.cursorPosition) {
        this.currentState = {
          text:
            this.currentState.text.substring(0, this.cursorPosition) +
            `{{ ${item.value} }}` +
            this.currentState.text.substring(this.cursorPosition)
        }
        this.refreshEditor()
      }
      this.dynamicAttr = ''
      this.putCursor('customAttrsInput')
    },

    putCursor(ref) {
      setTimeout(() => {
        this.$refs[ref].focus()
      }, 0)
    },

    hidePopover(data) {
      const refRect = data.offsets.reference
      const windowHeight = window.innerHeight
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64
      data.styles.display =
        refRect.bottom - headerHeight < 0 || refRect.top > windowHeight
          ? 'none'
          : 'block'
      return data
    },

    validate() {
      return this.editor.validate()
    },

    getPayload() {
      if (this.currentState && this.validate() === null) {
        return this.currentState.text
      }

      return undefined
    }
  }
}
</script>

<style scoped>
.JsonEditor-Buttons {
  display: flex;
  justify-content: end;
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 10px;
}
.dropdown-btn {
  padding: 8px;
  width: 35px;
  height: 35px;
  background-color: #fff;
}
.btn-group {
  display: flex;
}
.actions {
  position: absolute;
  z-index: 99;
  right: 0;
}
>>> .el-textarea__inner {
  padding-top: 31px !important;
  height: 120px;
  font-family: sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/common/components/JsonEditor.vue